import { UserRole } from './user-role';
import { Policy } from './policy';

export interface IPolicyRoles {
    policy: Policy;
    roles: UserRole[];
}
